import { render } from "./RealNews.vue?vue&type=template&id=ac83d2c6"
import script from "./RealNews.vue?vue&type=script&lang=js"
export * from "./RealNews.vue?vue&type=script&lang=js"

import exportComponent from "F:\\coding-project\\개발자품격\\제품판매웹앱구현\\카페24\\pro\\fastsell_login\\client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__